(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".accordion-section .accordion-item");

  items.forEach((item, index) => {
    const answer = item.querySelector(".answer");
    if (answer) {
      answer.style.overflow = "hidden";
      answer.style.transition = "max-height 0.3s ease-out";

      if (index === 0) {
        item.classList.add("active");
        answer.style.display = "block";
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = "0";
        answer.style.display = "none";
      }
    }

    item.addEventListener("click", function () {
      const isActive = this.classList.contains("active");

      this.closest(".accordion-list").querySelectorAll(".accordion-item.active").forEach((activeItem) => {
        activeItem.classList.remove("active");
        const activeAnswer = activeItem.querySelector(".answer");
        if (activeAnswer) {
          activeAnswer.style.maxHeight = "0";
          setTimeout(() => { activeAnswer.style.display = "none"; }, 300);
        }
      });

      if (!isActive) {
        this.classList.add("active");
        if (answer) {
          answer.style.display = "block";
          setTimeout(() => { answer.style.maxHeight = answer.scrollHeight + "px"; }, 10);
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hotspot-section').forEach(function (section) {
    var hotspots = section.querySelectorAll('.hotspot');

    section.querySelectorAll('.hotspot-dot').forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        var hotspot = dot.closest('.hotspot');
        var willOpen = !hotspot.classList.contains('is-open');
        hotspots.forEach(function (h) {
          h.classList.remove('is-open');
        });
        if (willOpen) hotspot.classList.add('is-open');
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.hotspot')) {
        hotspots.forEach(function (h) {
          h.classList.remove('is-open');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide-tab"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.size-guide').forEach(function (sg) {
    sg.querySelectorAll('.size-guide__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tab');
        sg.querySelectorAll('.size-guide__tab').forEach(function (t) {
          t.classList.remove('is-active');
        });
        sg.querySelectorAll('.size-guide__panel').forEach(function (p) {
          p.classList.remove('is-active');
        });
        tab.classList.add('is-active');
        var panel = sg.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id));
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
